import { Icon } from "../../../../../../elements";
import { useEffect, useState } from "react";

import {
  InputWrapper,
  InputField,
  SearchIcon
} from "../UserSelector.styled";

const SearchInput = ({ defaultValue = '', onChange, onClick, placeholder = "Search by name or last name" }) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    if (value !== defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue, value]);

  const onHandleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);

    if (onChange) {
      onChange(newValue);
    }
  }

  return (
    <InputWrapper>
      <InputField
        value={value}
        type="text"
        placeholder={placeholder}
        onChange={onHandleChange}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            setValue('');
            onChange && onChange('');
          }
        }}
      />
      <SearchIcon onClick={onClick}>
        <Icon name={"magnifier"} height={'20px'} width={'20px'} />
      </SearchIcon>
    </InputWrapper>
  );
}

export default SearchInput;